import { Card } from '@sravni/react-design-system';
import React, { useEffect } from 'react';

import { AppContainer } from 'shared/ui/AppContainer';

import styles from './styles.module.scss';

type Props = {
  Component: React.FC | (() => null);
  /** Чтобы картинка не показывалась при коротком отображении лоадера */
  shortDuration?: boolean;
};

const ActiveComponent: React.FC<Props> = ({ shortDuration, Component }) => {
  useEffect(() => {
    /** Прелоадим первую картинку, чтобы не было прыжка */
    import('shared/assets/icons/application.svg');
  }, []);

  return (
    <AppContainer className={styles.activeComponent}>
      <Card
        className={styles.card}
        size={16}
      >
        {!shortDuration && <Component />}
      </Card>
    </AppContainer>
  );
};

export const MainLoader = React.memo(ActiveComponent);
